import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appFloatNumber]',
})
export class FloatNumberTypeDirective {
  @Input() appFloatNumber: number;
  @Input() isPeakFlow: string;

  constructor() {}

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    const charCode = event.key;
    this.appFloatNumber = Number(this.appFloatNumber);
    let numberRegex;
    if (this.isPeakFlow === 'true') {
      numberRegex = new RegExp(`^[0-9\,]+$`);
    } else {
      numberRegex = new RegExp(`^[0-9\.,]+$`);
    }
    if (!numberRegex.test(charCode)) {
      event.preventDefault();
    } else if ((charCode === '.' || charCode === ',') && (event.target.value.indexOf('.') >= 0 || event.target.value.indexOf(',') >= 0)) {
      event.preventDefault();
    } else if (
      event.target.value.indexOf('.') >= 0 &&
      event.target.value.length - 1 - event.target.value.indexOf('.') === +this.appFloatNumber
    ) {
      event.preventDefault();
    } else if (
      event.target.value.indexOf(',') >= 0 &&
      event.target.value.length - 1 - event.target.value.indexOf(',') === +this.appFloatNumber
    ) {
      event.preventDefault();
    }
    return true;
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pasted = (event.clipboardData || (window as any).clipboardData)?.getData('text') ?? '';
    const allowedChars = this.isPeakFlow === 'true' ? /^[0-9,]+$/ : /^[0-9.,]+$/;
    if (!allowedChars.test(pasted)) {
      event.preventDefault();
      return;
    }
    const target = event.target as HTMLInputElement;
    const start = target.selectionStart ?? target.value.length;
    const end = target.selectionEnd ?? target.value.length;
    const resulting = target.value.substring(0, start) + pasted + target.value.substring(end);
    const separatorCount = (resulting.match(/[.,]/g) || []).length;
    if (separatorCount > 1) {
      event.preventDefault();
      return;
    }
    const decimals = Number(this.appFloatNumber);
    const separatorIndex = Math.max(resulting.indexOf('.'), resulting.indexOf(','));
    if (separatorIndex >= 0 && resulting.length - 1 - separatorIndex > decimals) {
      event.preventDefault();
    }
  }
}
